export async function fetchCopperGoldYield({
  copper = 'HG=F',
  gold = 'GLD',
  yieldSeries = 'DGS10',
  range = '5Y',
} = {}) {
  const params = new URLSearchParams({
    copper,
    gold,
    yield_series: yieldSeries,
    range,
    include_bars: '1',
  });
  const response = await fetch(`/api/investing/copper-gold-yield?${params}`);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    throw new Error(body?.error || `HTTP ${response.status}`);
  }
  return body;
}
